import React from 'react';
import type { ButtonProps } from 'antd/lib/button';
import { StyledButton } from './styles/ActionButton.styles';

export const ActionButton = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  return <StyledButton {...props} ref={ref} />;
});

ActionButton.displayName = 'ActionButton';
